/* global Swiper */
document.querySelectorAll( '.b-results' ).forEach( ( block ) => {

	/////////////////////
	// BLOCK CODE HERE //
	/////////////////////

	const blockSwiper = block.querySelector( '.b-results__swiper' );
	const slidesCount = block.querySelectorAll( '.b-results__swiper .swiper-slide' ).length;
	let sloop = false;
	if ( slidesCount > 1 ) {

		sloop = true;

	}
	new Swiper( blockSwiper, {
		slidesPerView: 1,
		spaceBetween: 0,
		loop: sloop,
		allowTouchMove: false,
		navigation: {
			nextEl: '.swiper-button-next',
			prevEl: '.swiper-button-prev',
		},
	} );

	const dragBox = document.querySelectorAll( '.b-results__content' );
	if ( dragBox.length > 0 ) {

		dragBox.forEach( ( el ) => {

			if ( el !== false && el !== null ) {

				const imageMask = el.querySelectorAll( '.b-results__photos .wp-block-image' )[ 1 ];

				if ( imageMask !== false && imageMask !== null ) {

					el.addEventListener( 'mousedown', dragEvent, false );
					el.addEventListener( 'touchstart', dragEvent, false );

				} else {

					el.removeEventListener( 'mousedown', dragEvent, false );
					el.removeEventListener( 'touchstart', dragEvent, false );

				}

				/**
				 *
				 * @return {void}
				 */
				function dragEvent( ) {

					/**
					 * Drag Event
					 *
					 * @param {number} pageX
					 * @return {void}
					 */
					function moveAt( pageX ) {

						const activeSlide = document.querySelector( '.swiper-slide-active' );
						const iMask = activeSlide.querySelectorAll( '.b-results__photos .wp-block-image' )[ 1 ];
						const iMarker = activeSlide.querySelector( '.b-results__photos-marker' );

						const shiftX = iMask.closest( '.b-results__photos' ).getBoundingClientRect().left;

						const pos = pageX - shiftX;

						if ( pos >= 0 && pos <= imageMask.offsetWidth ) {

							iMask.style.clipPath = `polygon(${ pos }px 0, 100% 0, 100% 100%, ${ pos }px 100%)`;
							iMarker.style.left = `${ pos }px`;

						}

					}
					/**
					 * Move event
					 *
					 * @param {event} event
					 * @return {void}
					 */
					function moveEvent( event ) {

						moveAt( event.pageX || event.targetTouches[ 0 ].pageX );

					}

					el.onmousedown = () => {

						el.addEventListener( 'mousemove', moveEvent );

					}

					el.onmouseup = () => {

						el.removeEventListener( 'mousemove', moveEvent );

					};
					el.addEventListener( 'touchmove', moveEvent );
					el.ontouchend = () => {

						el.removeEventListener( 'touchmove', moveEvent );

					};

				}

				el.ondragstart = () => {

					return false;

				};

			}

		} );

	}

} );
